export default __webpack_public_path__ + "static/media/unactive.5371358e.svg";